import { Tabs } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { getKlassenName } from "../Helper/PrKontoHelper";

export const KontenKlassenJahr = ({
  aktjahr,
  onChange,
  Child,
  tabPosition = "top",
}) => {
  const [items, setItems] = useState();
  const [aktKey, setAktKey] = useState(
    window.localStorage.getItem("KontoKlasse")
  );

  useEffect(() => {
    if (!items) {
      const xitems = [];
      if (Child) {
        for (let i = 0; i < 13; i++)
          xitems.push({
            key: `${i}`,
            label: getKlassenName(i),
            children: <Child />,
          });
      } else {
        for (let i = 0; i < 13; i++)
          xitems.push({ key: `${i}`, label: getKlassenName(i), });
      }
      setItems(xitems);
    }
  }, []);

  const myOnchange = (key) => {
    setAktKey(key);
    window.localStorage.setItem("KontoKlasse", key);
    if (onChange) {
      onChange(key);
    }
  };
  return (
    <>
      <Tabs
        size="small"
        tabPosition={tabPosition}
        // activeKey={window.localStorage.getItem("KontoKlasse")}
        // defaultActiveKey={aktKey}
        activeKey={aktKey}
        items={items}
        onChange={myOnchange}
      />
    </>
  );
};
